import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import axios from "axios";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react/button";
import FormField from "../../dynamicFormBuilder/FormField";
import { DetailCommentsLayout } from "./Layout";
import { GetFormatedDateWithTime } from "../../common/Utils";
import { CONCURRENCY_HANDLED, getApiErrorMessage } from "../../common/concurrency";
import data from "../../assets/apiRoutes.json";
import { EMPTY_GUID } from "../../const/constants";

const ROUTES = data.IM.ItemManagement;

// Details -> "Comments" sub-tab (Delphi uIMD0019 Details/Comments): the SELECTED line's Comment + User
// Comment. Editable; Save posts the whole line (UpdateTransactionDetailByRowId).
function DetailCommentsTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const accessToken = props.oidc?.user?.access_token;

    const line = props.formFields || {};
    const hasLine = line.rowid && line.rowid !== EMPTY_GUID;
    const editable = hasLine && !props.disabled;

    const finalLayout = useMemo(() => DetailCommentsLayout, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        if (props.handleFieldChange) props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    const handleFormLoad = useCallback(() => {}, []);

    const save = useCallback(() => {
        if (!hasLine) { notify("Select a detail line first.", "warning", 3000); return; }
        const payload = { ...line, transactionDate: line.transactionDate ? GetFormatedDateWithTime(line.transactionDate) : null };
        axios.post(`${window._env_.REACT_APP_APIS}/${ROUTES.UpdateTransactionDetailByRowId}`, payload, {
            headers: {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        }).then((res) => {
            notify("Comments saved.", "success", 3000);
            if (props.onSaved) props.onSaved(res.data);
        }).catch((err) => {
            if (err?.[CONCURRENCY_HANDLED]) return;
            notify(getApiErrorMessage(err, "Failed to save comments."), "error", 5000);
        });
    }, [hasLine, line, accessToken, props]);

    if (!hasLine) {
        return <div style={{ padding: 16, color: "#888" }}>Select a detail line to view or edit its comments.</div>;
    }

    return (
        <div>
            <div style={{ textAlign: "right", marginBottom: 4 }}>
                <Button text="Save" type="default" onClick={save} disabled={!editable} />
            </div>
            <FormField
                currrentUser={currentUser}
                layoutId="EB8D25B3-29DA-4E4B-8879-B7DB08E3395E"
                layoutName="IMTransactionEntryDetailCommentsForm"
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(DetailCommentsTab);
